import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useAtom } from 'jotai';

import { SkeletonEmployerCardLoading } from '@restworld/ui-components';
import { useEmployerUserContactData, useEmployerUserInformationLoadingState } from '@restworld/feature-authentication';

import { UserSettingsDataView } from './user-settings-data-view';
import { ComponentLayout, ModalEditKey } from '.';
import { emailSentFlagAtom } from './update-user-email-modal';

export const ContactInformationSection = () => {
  const { t } = useTranslation('user-settings');
  const employerUserInformation = useEmployerUserContactData();
  const loading = useEmployerUserInformationLoadingState();
  const [emailSentFlag] = useAtom(emailSentFlagAtom);

  const placeHolderData = React.useMemo(
    () => [
      {
        label: t('email_address'),
        value: '',
        isEditable: true,
        key: 'email' as ModalEditKey,
      },
      { label: t('phone_number'), value: '', isEditable: true, key: 'phone_number' as ModalEditKey },
      {
        label: t('how_do_you_prefer_to_be_contacted'),
        value: '',
        isEditable: true,
        key: 'communication_pref' as ModalEditKey,
      },
      {
        label: t('notification_title'),
        value: '',
        isEditable: true,
        key: 'manage_notifications' as ModalEditKey,
      },
    ],
    [t]
  );

  const accountData = React.useMemo(() => {
    if (employerUserInformation?.user_id) {
      const {
        user: { email, phone_number: phoneNumber },
        preferred_communication_channel_var,
      } = employerUserInformation;
      placeHolderData.reduce((acc, item) => {
        if (item.key === 'email') item.value = emailSentFlag ? t('verify_email') : email || t('not_specified');
        if (item.key === 'phone_number') item.value = phoneNumber || t('not_specified');
        if (item.key === 'communication_pref')
          item.value = preferred_communication_channel_var?.label || t('not_specified');
        if (item.key === 'manage_notifications') item.value = '';
        return acc;
      }, []);
      return placeHolderData;
    }
    return placeHolderData;
  }, [emailSentFlag, employerUserInformation, placeHolderData, t]);
  return (
    <ComponentLayout title={t('contact_information_title')}>
      {loading ? <SkeletonEmployerCardLoading /> : <UserSettingsDataView data={accountData} />}
    </ComponentLayout>
  );
};
